<template>
  <div class="loader-container" :style="containerStyle">
    <div class="loader-content">
      <img src="/capsiminbox/images/loader.gif" alt="Processing animation" />
      <span class="text" :style="textStyle">{{ loaderText }}</span>
      <div class="optional-content mt-20">
        <div>{{ optionalFirstText }}</div>
        <br />
        <div>{{ optionalSecondText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'loader',
    props: {
      loaderText: {
        type: String,
        required: false,
        default: 'Processing...',
      },
      containerStyle: {
        type: [String, Object],
        required: false,
      },
      textStyle: {
        type: [String, Object],
        required: false,
      },
      optionalFirstText: {
        type: String,
        required: false,
        default: '',
      },
      optionalSecondText: {
        type: String,
        required: false,
        default: '',
      },
    },
  };
</script>

<style lang="scss" scoped>
  .loader-container {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 1;
  }

  .loader-content {
    position: absolute;
    width: fit-content;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  img {
    width: 80px;
  }

  .text {
    font-family: sans-serif;
    font-size: xx-large;
    font-weight: bold;
  }
  .optional-content {
    position: relative;
    top: 70%;
    text-align: center;
  }
</style>
